import Vue from 'vue';
import Router from 'vue-router';
import login from '@/components/page/login';
import start from '@/components/page/start';
import main from '@/components/page/main';
import Service_inspection from '@/components/page/Service_inspection';
import admin_login from '@/components/page/admin_login';
import payment_cancel from '@/components/page/payment_cancel';
import Payment_locker from '@/components/page/Payment_locker';
import Payment_group_room from '@/components/page/Payment_group_room';
import Payment_group_room_product from '@/components/page/Payment_group_room_product';
import Payment_group_room_reservation from '@/components/page/Payment_group_room_reservation';
import Payment_etc from '@/components/page/Payment_etc';
import Payment_seat from '@/components/page/Payment_seat';
import Payment_seat_product from '@/components/page/Payment_seat_product';
import price_list from '@/components/page/price_list';
import mypage from '@/components/page/mypage';
import register from '@/components/page/Register';
import password_edit from '@/components/page/password_edit';
import cafe_out from '@/components/page/cafe_out';
import Payment_reservation from '@/components/page/Payment_reservation';
import Payment_mileage from '@/components/page/Payment_mileage';
import store from '@/components/page/store';
import front_main from '@/components/page/front_main';
import barcode from '@/components/page/barcode';
Vue.use(Router) //app.vue main caller

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'main',
      component: main
    },
    {
      path: '/start',
      name: 'start',
      component: start
    },
    {
      path: '/admin_login',
      name: 'admin_login',
      component: admin_login
    },
    {
      path: '/payment_cancel',
      name: 'payment_cancel',
      component: payment_cancel
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/password_edit',
      name: 'password_edit',
      component: password_edit
    },
    {
      path: '/payment-seat',
      name: 'Payment_seat',
      component: Payment_seat
    },
    {
      path: '/payment-seat_product',
      name: 'Payment_seat_product',
      component: Payment_seat_product
    },
 
    {
      path: '/payment-locker',
      name: 'Payment_locker',
      component: Payment_locker
    },
    {
      path: '/payment-group_room',
      name: 'Payment_group_room',
      component: Payment_group_room
    },
    {
      path: '/payment-group_room_product',
      name: 'group_room_product',
      component: Payment_group_room_product
    },
    {
      path: '/payment-group_room_reservation',
      name: 'group_room_reservation',
      component: Payment_group_room_reservation
    },
    // 251127 모바일 기타상품 결제 추가
    {
      path: '/payment-etc',
      name: 'Payment_etc',
      component: Payment_etc
    },
    {
      path: '/price_list',
      name: 'price_list',
      component: price_list
    },
    {
      path: '/mypage',
      name: 'mypage',
      component: mypage 
    },
    {
      path : '/cafe_out',
      name: 'cafe_out',
      component : cafe_out
    },
    {
      path: '/Payment_reservation',
      name: 'Payment_reservation',
      component: Payment_reservation
    },
    {
      path: '/payment_mileage',
      name: 'Payment_mileage',
      component: Payment_mileage
    },
    {
      path: '/store',
      name: 'store',
      component: store
    },
    {
      path: '/front_main',
      name: 'front_main',
      component: front_main
    },
    {
      path: '/barcode',
      name: 'barcode',
      component: barcode
    },
    {
      path: '/service_inspection',
      name: 'service_inspection',
      component: Service_inspection
    },
  ]
})

const startTime = new Date('2025-01-22T02:00:00')
const endTime = new Date('2025-01-22T07:00:00')

// 라우터 전역 가드 추가
router.beforeEach((to, from, next) => {
  const now = new Date()

  // 특정 시간 범위에 해당하는 경우
  if (now >= startTime && now <= endTime && to.path !== '/service_inspection') {
    next('/service_inspection') // 강제 리다이렉트
  } else {
    next() // 원래 이동 경로로 이동
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js